import amplitude from "amplitude-js";
import axios from "axios";
import { makePropertiesObj } from "../helper";
import DEPLOYMENT_SETTINGS from "../../environmentSettings";

// making this true to prevent amplitude calls because amplitude is not in use as of now
const isLocalhost = true
// Boolean(
// 	window.location.hostname === "localhost" ||
// 		// [::1] is the IPv6 localhost address.
// 		window.location.hostname === "[::1]" ||
// 		// 127.0.0.1/8 is considered localhost for IPv4.
// 		window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
// );
// Query Builder Details
const demoQB = "3478ebad9d92f05335201f296c222973";
const liveQB = "e65f2b670f66ccf8866930c290b68671";
const demoQBInstance = amplitude.getInstance("demoQB");
const liveQBInstance = amplitude.getInstance("liveQB");
// Canvas (Dashboard Designer Details)
const demoCanvas = "fd47dc4032ac26dc92f230db46ebdb31";
const liveCanvas = "2e2da1964e13a999af28b95b5b598cd3";
const demoCanvasInstance = amplitude.getInstance("dashboardDesigner");
const liveCanvasInstance = amplitude.getInstance("liveDashboardDesigner");
// New instance for all live canvas events
const liveCanvasAppNew = "95a69a55b448e9faf6f0eafdbeaf8e8a";
const liveCanvasAppNewInstance = amplitude.getInstance("canvasAppNew");

// let ddInstance; commented the previous amplitude events
let newInstance;

const getAPIKey = href => {
	return href.includes("queryBuilder")
		? href.includes("demo") || isLocalhost
			? demoQB
			: liveQB
		: href.includes("dashboardBuilder")
		? href.includes("demo") || isLocalhost
			? demoCanvas
			: liveCanvasAppNew
		: "";
};

const getInstance = href => {
	return href.includes("queryBuilder")
		? href.includes("demo") || isLocalhost
			? demoQBInstance
			: liveQBInstance
		: href.includes("dashboardBuilder")
		? href.includes("demo") || isLocalhost
			? demoCanvasInstance
			: liveCanvasInstance
		: "";
};

/** Amplitude initialises and starts a session when an app opens or reloads and then start tracking the events
 * Calling it once in APP would do the needful (Already done)
 */
export const initialiseAmplitude = (userId, href) => {
	// ddInstance = getInstance(href);
	newInstance = href.includes("demo") ? getInstance(href) : liveCanvasAppNewInstance;
	try {
		if (!isLocalhost) {
			// ddInstance.init(getAPIKey(href), userId);
			newInstance.init(href.includes("demo") ? getAPIKey(href) : liveCanvasAppNew, userId);
		}
	} catch (error) {
		console.log(`Unable to Initialise Amplitude : ${error}`);
	}
};

/**
 * tracks the user from when a session starts and store user properties as userId and whether a user is a gooder or not
 * Calling it once just tracks it for every event in that session (already done)
 */
export const setUserProperties = () => {
	try {
		if (!isLocalhost) {
			const accessToken = localStorage.getItem("$LoopBack$accessTokenId");
			const userId = localStorage.getItem("$LoopBack$currentUserId");
			let email = "";
			let userType = "";
			axios
				.get(DEPLOYMENT_SETTINGS.apiConfig.p3fyUrl + "/users/" + userId, {
					headers: { Authorization: accessToken }
				})
				.then(res => res.data)
				.then(data => {
					email = data.email;
					if (email && email.includes("uniqus")) {
						userType = "Internal";
					} else {
						userType = "External";
					}
					// ddInstance.setUserId(userId);
					// ddInstance.setUserProperties({
					// 	userId: userId,
					// 	userType: userType
					// });

					newInstance.setUserId(userId);
					newInstance.setUserProperties({
						userId,
						userType
					});
				});
		}
	} catch (error) {
		console.log(`User properties : failed to set : ${error}`);
	}
};

/**
 *   Returns an object of most common event properties that needs to be tracked for a particular event. These properties include dashboardContainerName, dashboardName, orgId
 *   Arguments taken : dashboardContainer(Array of dashboard containers), organization Id, dashboardContainerId and dashboardId for that particular dashboard
 */

export const makeAmplitudeObj = (dashboardContainer, orgId, dashboardContainerId, dashboardId) => {
	try {
		if (!isLocalhost) {
			return makePropertiesObj(dashboardContainer, orgId, dashboardContainerId, dashboardId);
		}
	} catch (error) {
		console.log(`Could not make amplitude Object : ${error}`);
	}
};

/**
 * This function is responsible for tracking any event
 * Arguments taken : name of the event to be tracked, and an object including the eventProperties to be tracked
 * If the properties are common as in makeAmplitudeObj, call that first and then in resulting obj add extra eventProp(if Any)
 */
export const logThisEvent = (eventName, eventProperties) => {
	try {
		if (!isLocalhost) {
			// ddInstance.logEvent(eventName, eventProperties);
			newInstance.logEvent(eventName, eventProperties);
		}
	} catch (error) {
		console.log(`Amplitude : failed to log the event : ${error}`);
	}
};

export let amplitudeEventParams = {
	orgId: "",
	dashboardContainerId: "",
	dashboardContainerName: "",
	dashboardId: "",
	dashboardName: "",
	widgetId: "",
	widgetName: "",
	uiScreen: ""
};

export const populateAmplitudeParams = updatedParams => {
	amplitudeEventParams = {
		...amplitudeEventParams,
		...updatedParams
	};
};

/**
 * This function is responsible for finding ui_screen when origin is not known
 */
export const findOriginofEvent = () => {
	const { pathname } = window.location;
	if (pathname.includes("dashboardBuilder")) {
		if (pathname.includes("editor")) return "editor";
		if (pathname.includes("preview")) return "preview";
		if (pathname.includes("widgets")) return "configureWidget";
		if (pathname.includes("filters")) return "configureFilters";
		if (pathname.includes("navigationManagement")) return "navigationManagement";
	} else if (pathname.includes("queryBuilder")) {
		if (pathname.includes("devMode")) return "devMode";
		if (pathname.split("/").length == 3) return "queryList";
		return "builderMode";
	} else if (pathname.includes("userManagement")) return "userManagement";
	else if (pathname.includes("themeSettings")) return "themeSettings";
	return "Organization Listing";
};

/**
 * This function is responsible for finding the app( dashboard builder / query builder)
 */
export const findAppContext = () => {
	const { pathname } = window.location;
	if (pathname.includes("queryBuilder")) return "Query Builder";
	if (pathname.includes("dashboardBuilder")) return "Dashboard Builder";
	return "Canvas";
};
